<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditDialog="openEditDialog"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <el-badge
          v-if="allow('B')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('B')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="purchasableApproved"
          >
            {{ $l('btn_approved_batch') || '审核通过' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>

        <el-badge
          v-if="allow('F')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('F')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="rejected"
          >
            {{ $l('btn_rejected_batch') || '审核驳回' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <SkuDetail
      v-if="skuDetailOpts.visible"
      :type="skuDetailOpts.type"
      :visible.sync="skuDetailOpts.visible"
      :amzSkuCode="skuDetailOpts.amzSkuCode"
      :applicationStatus="skuDetailOpts.applicationStatus"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import SkuDetail from '../detail'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, SkuDetail },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      skuDetailOpts: {
        visible: false,
        type: '',
        amzSkuCode: '',
        applicationStatus: '',
      },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzSkuListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, data = {} } = {}) {
      const { amzSkuCode, applicationStatus } = data
      this.skuDetailOpts = {
        visible: true,
        type,
        amzSkuCode,
        applicationStatus,
      }
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    rejected() {
      if (!this.checkedRowCount) {
        this.$message({
          message: '请选择需要通过信息确认的SKU',
          type: 'warning',
        })
        return
      }
      const listAmzSkuCode = this.checkedRows.map((item) => item.amzSkuCode)
      this.$prompt(
        this.$l('tips_review') || '是否要驳回信息确认申请？',
        '提示',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          inputPlaceholder: '请输入驳回原因',
          inputType: 'textarea',
          inputValidator: (value) => {
            if (value) {
              return true
            }
            return '请输入驳回原因'
          },
          inputErrorMessage: '请输入驳回原因',
        }
      )
        .then(({ value }) => {
          if (this.loadingOpen()) return
          this.$api
            .ecomAmzSkuInformationRejectApi({
              listAmzSkuCode,
              rejectReason: value,
            })
            .then((res) => {
              this.loadingClose()
              const { status } = res
              if (status == 200) {
                this.$message({
                  showClose: true,
                  message: this.$l('tips_review_success') || '驳回成功',
                  type: 'success',
                })
              }
              this.clearCheckboxRow()
              this.reload()
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {})
    },
    async purchasableApproved() {
      if (!this.checkedRowCount) {
        this.$message({
          message: '请选择需要通过信息确认的SKU',
          type: 'warning',
        })
        return
      }
      const confirm = await this.$confirm(
        '是否要通过信息确认申请？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return false
      if (this.loadingOpen()) return
      const listAmzSkuCode = this.checkedRows.map((item) => item.amzSkuCode)
      const res = await this.$api
        .ecomAmzSkuInformationApprovedApi({ listAmzSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_pass_failed') || '通过失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_pass_success') || '通过成功！',
        type: 'success',
      })
      this.clearCheckboxRow()
      this.reload()
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
